/**
 * @overview 游戏相关全局数据
 *
 * @author huojinzhao
 */

import { $http } from "@/utils";

export default {
  namespaced: true,

  state: {
    types: [],
  },

  actions: {
    initTypes({ commit }) {
      return $http.get("/game/index_before")
        .then(({ type }) => {
          let data = [];
          if (Array.isArray(type)) {
            data = type.filter(item => item.value !== 30); // 过滤连一连、练一练
            // data.push({
            //   name: "游戏包",
            //   value: 666,
            // });
            commit("initTypes", data);
          }
          return data;
        });
    },
  },

  mutations: {
    initTypes(state, types) {
      state.types = types;
    },
  },
};
